/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://statefulcoders.com/product/material-dashboard-react
* Copyright 2025 Stateful Coders (https://https://statefulcoders.com)

Coded by https://statefulcoders.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
 * The base breakpoints for the Material Dashboard 2 React.
 * You can add new breakpoints using this file.
 * You can customized the breakpoints for the entire Material Dashboard 2 React using thie file.
 */

const breakpoints = {
  values: {
    xs: 0,        // Extra small devices (phones, 0px and up)
    sm: 576,      // Small devices (landscape phones, 576px and up)
    md: 768,      // Medium devices (tablets, 768px and up)
    lg: 992,      // Large devices (desktops, 992px and up)
    xl: 1200,     // Extra large devices (large desktops, 1200px and up)
    xxl: 1400,    // Extra extra large devices (larger desktops, 1400px and up)
  },

  // Additional utility breakpoints for common device sizes
  keys: ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'],

  // Common device breakpoints for reference
  devices: {
    mobile: 480,      // Mobile devices
    mobileLarge: 576, // Large mobile devices
    tablet: 768,      // Tablets
    tabletLarge: 992, // Large tablets / small laptops
    desktop: 1200,    // Desktop
    desktopLarge: 1400, // Large desktop
  },
};

export default breakpoints;
